import React, { useState } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

export default function MdReferralForm({
  formData,
  setFormData,
  formErrors,
  smsConsent,
  setSmsConsent
}) {
  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const physicians = [
    { value: 'next_rei', label: 'Next REI' },
    { value: 'pr', label: 'Dr. Paul Robb' },
    { value: 'ra', label: 'Dr. Rebecca Arthur' },
    { value: 'ag', label: 'Dr. Ashley Gilman' },
    { value: 'sm', label: 'Dr. Shannon Moore' },
    { value: 'cs', label: 'Dr. Carrie Schram' },
    { value: 'ef', label: 'Eileen McMahon' },
    { value: 'ncp', label: 'NCP' },
    { value: 'no_calendar', label: 'No Calendar' }
  ];

  // const [phoneNumber, setPhoneNumber] = useState(formData.patient_phone_number || ['']);
  const phoneNumber = formData.patient_phone_number || [''];

  // const handlePhoneChange = (index, value) => {
  //   const updatedPhones = [...phoneNumber];
  //   updatedPhones[index] = value;
  //   setPhoneNumber(updatedPhones);
  //   setFormData({ ...formData, patient_phone_number: updatedPhones });
  // };

  // const addPhoneField = () => {
  //   setPhoneNumber([...phoneNumber, '']);
  // };

  const formatPhone = (e, idx) => {
    const digits = e.target.value.replace(/\D/g, '');
    const match = digits.match(/^1?([2-9]\d{2})([2-9]\d{2})(\d{4})$/);
    if (match) {
      const formatted = `(${match[1]}) ${match[2]}-${match[3]}`;
      const updatedPhones = [...phoneNumber];
      updatedPhones[idx] = formatted;
      setFormData({ ...formData, patient_phone_number: updatedPhones });
    }
  };

  console.log(formData);

  return (
    <>
      <h1 className="text-center mb-5">MD Referral Form</h1>

      <Form.Group className="mb-3">
        <Form.Label className="required">Patient Name</Form.Label>
        <Row>
          <Col>
            <Form.Control type="text" name="patient_first_name" maxLength={22} required value={formData.patient_first_name || ''} onChange={handleChange} isInvalid={formErrors?.patient_first_name} />
            <div className="text-muted small mt-1">First Name</div>
          </Col>
          <Col>
            <Form.Control type="text" name="patient_last_name" maxLength={22} required value={formData.patient_last_name || ''} onChange={handleChange} isInvalid={formErrors?.patient_last_name} />
            <div className="text-muted small mt-1">Last Name</div>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="required">Patient Phone Number</Form.Label>
        {phoneNumber.map((phone, idx) => (
          <Row key={idx} className="mb-2">
            <Col xs={8}>
              <Form.Control
                type="tel"
                required={idx === 0} // Only first phone required
                value={phone}
                onChange={e => {
                  const updatedPhones = [...phoneNumber];
                  updatedPhones[idx] = e.target.value;
                  // setPhoneNumber(updatedPhones);
                  setFormData({
                    ...formData,
                    patient_phone_number: updatedPhones
                  });
                }}
                isInvalid={formErrors?.patient_phone_number?.[idx]}
                onBlur={e => formatPhone(e, idx)}
                pattern="^[+()0-9\\s-]+$"
              />
            </Col>

            <Col xs="auto">
              {/* Add button only on last field */}
              {idx === phoneNumber.length - 1 && (
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    if (phoneNumber[phoneNumber.length - 1].trim() !== '') {
                      setFormData({
                        ...formData,
                        patient_phone_number: [...phoneNumber, '']
                      });
                    }
                  }}
                >
                  +
                </Button>
              )}
            </Col>

            <Col xs="auto">
              {/* Remove button for all except first */}
              {idx > 0 && (
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    const updatedPhones = phoneNumber.filter((_, i) => i !== idx);
                    // setPhoneNumber(updatedPhones);
                    setFormData({
                      ...formData,
                      patient_phone_number: updatedPhones
                    });
                  }}
                >
                  –
                </Button>
              )}
            </Col>
          </Row>
        ))}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check id="md-referral-sms-consent">
          <Form.Check.Input
            type="checkbox"
            name="sms_consent"
            required
            checked={smsConsent}
            onChange={e => setSmsConsent(e.target.checked)}
            isInvalid={formErrors?.sms_consent}
          />
          <Form.Check.Label className="required">
            The patient has agreed to receive text messages from Hannam
            Fertility Centre about this referral. Message and data rates may
            apply. They can reply STOP to opt out.
          </Form.Check.Label>
        </Form.Check>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="required">Referral Source</Form.Label>
        <Form.Select name="referral_source" required value={formData.referral_source || ''} onChange={handleChange} isInvalid={formErrors?.referral_source}>
          <option value="">Select...</option>
          <option value="MD">MD</option>
          <option value="CCRM">CCRM</option>
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="required">Patient refer to</Form.Label>
        <Form.Select name="doctor_calendar" required value={formData.doctor_calendar || ''} onChange={handleChange} isInvalid={formErrors?.doctor_calendar}>
          <option value="">Select...</option>
          {physicians.map(doc => (
            <option key={doc.value} value={doc.value}>
              {doc.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="required">Referring Doctor Name</Form.Label>
        <Row>
          <Col>
            <Form.Control type="text" name="md_first_name" maxLength={22} required value={formData.md_first_name || ''} onChange={handleChange} isInvalid={formErrors?.md_first_name} />
            <div className="text-muted small mt-1 ">First Name</div>
          </Col>
          <Col>
            <Form.Control type="text" name="md_last_name" maxLength={22} required value={formData.md_last_name || ''} onChange={handleChange} isInvalid={formErrors?.md_last_name} />
            <div className="text-muted small mt-1 ">Last Name</div>
          </Col>
        </Row>
      </Form.Group>
    </>
  );
}
